import { terUtilsGetIdentPanel, terUtilsUnitsMilimetriToMetri, terUtilsUnitsMilimetriKvadratniToMetriKvadratni, terUtilsNumberRoundUp, terUtilsNumberRoundClassic } from './ter-utils';
import { AND, XIF, OR } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { SINGLE_PIECE, SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';
import { draftel_codecs_pack_terkk$_bundle_panel, _terkk_panel_multiflag_tippanela_helper } from './ter-draftel-codec-lib-terkk-bundle-panel';
import { js_utils } from '../utils/frfr-js-utils';
import { _derivatModulProfil_extract_50_ili_70_by_vrstaprofila } from './ter-derivat-lib-terkk-uni-dimenzije';
import { _getParamsFromLibMaterijalLimParams } from './ter-materijal-utils';


export const derivat_bundle_panel_pripremi_pods_input_inherited_za_draftel = (virtel_k, virtel_m) => {
  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input_inherited = {
    ...draftel_codecs_pack_terkk$_bundle_panel.default_pods_input_state(),
    tipkomore: virtel_k.tipkomore,
    unutrasnjaoplata: virtel_k.unutrasnjaoplata,
    tipispuneklimakomore: virtel_k.tipispuneklimakomore,
    vrstaprofila: virtel_m.vrstaprofila, // TODO Da li treba od komore ili od modula da povlaci ovo?
    "_extra_siframodula": null, // NOVO 2025-03-18
  };
  return pods_input_inherited;
};


/*
viretelsemakey
terkk$panel$derivat1
terkk$panel$materijal1
terkk$panel$materijal2
*/

/*
KOD PANELA
ono sto ide u polje tip to je materijal unutrasnji lim i on treba i u Par16 da ide isti podatak
unutrasnji lim isto za par14 njega uzimam iz drugog poluproizvoda LIM polje tiip...
ali oba se pojavlju u sastvnici export samo za PANEL a ne zna njegove poluproizvode
znaci od LIMA TIP se prebacuje na roditelj poluproizvod.
Par 15 izvlacim iz kamenavuna TIP
od Par1 do par13 sve imam


ubuduce poluproizvod kamena vuna preimenovati u ispuna panela
a njegov materijal je kamena vuna i poliuretan

TODO standardni neka bude velika slova STANDARDNI
*/


//
export const _derivat_terkk_panel_izracunaj_materijale = (pods_input, cparams_combined) => {
  // NOVO 2024-01-22
  /*
  panel_materijal_lim_spoljasnji,
  panel_materijal_lim_unutrasnji_redovni,
  panel_materijal_lim_unutrasnji_redovni_podni,
  panel_materijal_lim_unutrasnji_hygiene_prohrom,
  panel_materijal_lim_unutrasnji_hygiene_plastificirani,
  panel_materijal_lim_unutrasnji_hygiene_podni,
  */
  /*
  iz CPARMS za panel
  terkk_materijal_ident: {
    // panel
    panel_materijal_lim_default: "LBMAU00A", // default
    panel_materijal_lim_spoljasnji: "LBMAU00A", // spoljasni lim uvek isti tip // isto kao default
    panel_materijal_lim_unutrasnji_redovni: "LBMAU00A", // Svi sem podnog // isto kao default
    panel_materijal_lim_unutrasnji_redovni_podni: "LBJAR00D", //
    panel_materijal_lim_unutrasnji_hygiene_prohrom: "LC00000A",
    panel_materijal_lim_unutrasnji_hygiene_plastificirani: "LBMAU00A", // isto kao default
    panel_materijal_lim_unutrasnji_hygiene_podni: "LC00000D",
    panel_materijal_kamenavuna: "IAGIA45",
    panel_materijal_poliuretan: "IFF0030A0045",
    ...
  },
  */
  if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_string_not_empty(cparams_combined.terkk_materijal_ident.panel_materijal_lim_spoljasnji)) { // validate cparams TODO
    // By cparmas
    let _cpci = {};
    if (cparams_combined && cparams_combined.terkk_materijal_ident && js_utils.is_object(cparams_combined.terkk_materijal_ident)) { // validate cparams TODO
      // By cparmas
      _cpci = cparams_combined.terkk_materijal_ident;
    }
    const panel_materijal_lim_spoljasnji = _cpci.panel_materijal_lim_spoljasnji;
    const panel_materijal_lim_unutrasnji_redovni = _cpci.panel_materijal_lim_unutrasnji_redovni;
    const panel_materijal_lim_unutrasnji_redovni_podni = _cpci.panel_materijal_lim_unutrasnji_redovni_podni;
    const panel_materijal_lim_unutrasnji_hygiene_prohrom = _cpci.panel_materijal_lim_unutrasnji_hygiene_prohrom;
    const panel_materijal_lim_unutrasnji_hygiene_plastificirani = _cpci.panel_materijal_lim_unutrasnji_hygiene_plastificirani;
    const panel_materijal_lim_unutrasnji_hygiene_podni = _cpci.panel_materijal_lim_unutrasnji_hygiene_podni;
    const panel_materijal_lim_spoljasnji_panelbezprofila = _cpci.panel_materijal_lim_spoljasnji_panelbezprofila;
    const panel_materijal_lim_unutrasnji_panelbezprofila = _cpci.panel_materijal_lim_unutrasnji_panelbezprofila;
    //
    return {
      panel_materijal_lim_spoljasnji,
      panel_materijal_lim_unutrasnji_redovni,
      panel_materijal_lim_unutrasnji_redovni_podni,
      panel_materijal_lim_unutrasnji_hygiene_prohrom,
      panel_materijal_lim_unutrasnji_hygiene_plastificirani,
      panel_materijal_lim_unutrasnji_hygiene_podni,
      panel_materijal_lim_spoljasnji_panelbezprofila,
      panel_materijal_lim_unutrasnji_panelbezprofila,
    };
  } else {
    // OLD v1 kod starjih smartboma gde nije bilo cparams
    //
    const _default_tip_v1 = "LBMAU00A"; // default "LBMAU00A" Naziv: 'LIM GS S280GD, gloss 50% RAL 9010, 0.50x1220x3000mm';
    // _default_materijali_v1 sluze da zadrze kompatibilnost sa starim sastavnicama pre cparams
    const _default_materijali_v1 = {
      panel_materijal_lim_default: _default_tip_v1, // default
      panel_materijal_lim_spoljasnji: "LBMAU00A", // spoljasni lim uvek isti tip
      panel_materijal_lim_unutrasnji_redovni: _default_tip_v1, // // Svi sem podnog LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50 // isti kao default
      panel_materijal_lim_unutrasnji_redovni_podni: "LBJAR00D", // Podni LBJAR00D - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80
      panel_materijal_lim_unutrasnji_hygiene_prohrom: "LC00000A", // LC00000A - LIM SS 0.50
      panel_materijal_lim_unutrasnji_hygiene_plastificirani: _default_tip_v1, // isto kao default
      panel_materijal_lim_unutrasnji_hygiene_podni: "LC00000D", // Podni LC00000D - LIM SS 0.80
      panel_materijal_lim_spoljasnji_panelbezprofila: "LBMAU00A",
      panel_materijal_lim_unutrasnji_panelbezprofila: "LBMAU00A",
    };
    //
    // ----- spoljasnji
    const panel_materijal_lim_spoljasnji = _default_materijali_v1.panel_materijal_lim_spoljasnji; //
    // ----- unutrasnji za tipkomore === 'STD:pro' || tipkomore === 'HYDRA:pro' || tipkomore === 'ENERGY:pro'
    const panel_materijal_lim_unutrasnji_redovni = _default_materijali_v1.panel_materijal_lim_unutrasnji_redovni;
    const panel_materijal_lim_unutrasnji_redovni_podni = _default_materijali_v1.panel_materijal_lim_unutrasnji_redovni_podni;
    // ----- unutrasnji HYGIENE:pro
    const panel_materijal_lim_unutrasnji_hygiene_prohrom = _default_materijali_v1.panel_materijal_lim_unutrasnji_hygiene_prohrom;
    const panel_materijal_lim_unutrasnji_hygiene_plastificirani = _default_materijali_v1.panel_materijal_lim_unutrasnji_hygiene_plastificirani;
    const panel_materijal_lim_unutrasnji_hygiene_podni = _default_materijali_v1.panel_materijal_lim_unutrasnji_hygiene_podni;
    const panel_materijal_lim_spoljasnji_panelbezprofila = _default_materijali_v1.panel_materijal_lim_spoljasnji_panelbezprofila;
    const panel_materijal_lim_unutrasnji_panelbezprofila = _default_materijali_v1.panel_materijal_lim_unutrasnji_panelbezprofila;
    //
    return {
      panel_materijal_lim_spoljasnji,
      panel_materijal_lim_unutrasnji_redovni,
      panel_materijal_lim_unutrasnji_redovni_podni,
      panel_materijal_lim_unutrasnji_hygiene_prohrom,
      panel_materijal_lim_unutrasnji_hygiene_plastificirani,
      panel_materijal_lim_unutrasnji_hygiene_podni,
      panel_materijal_lim_spoljasnji_panelbezprofila,
      panel_materijal_lim_unutrasnji_panelbezprofila,
    };
  }
};


//
export const _derivatPoluproizvod_panel_naziv = (p, tipkomore, unutrasnjaoplata, tipispuneklimakomore, _is_top_level_vrata) => {
  const I3 = tipkomore; // tip komore

  let I4 = ''; // unutrasnja oplata
  if (unutrasnjaoplata) {
    I4 = unutrasnjaoplata;
  };
  let I5 = tipispuneklimakomore;
  console.log('p', p);
  let I7 = ''; // KLJUC
  if (p.kljuc) {
    I7 = p.kljuc; // KLJUC
  };
  let I8 = ''; // Sigurnosna brava
  if (p.sigurnosnabrava) {
    I8 = p.sigurnosnabrava; // Sigurnosna brava
  }
  let sirina = p.sirina;
  let visina = p.visina;

  const TIPPANELA = p.tippanela.toUpperCase();
  // let I14 = "PANEL " + TIPPANELA + " " + sirina + "x" + visina + " " + "R";
  let _prva_rec = "PANEL ";
  if (p.tippanela === 'vrata') {
    if (_is_top_level_vrata === true) {
      // izostavljamo prefix "PANEL " kada je na top level virtel tip vrata
      _prva_rec = "";
    };
  }
  if (p.tippanela === 'panelbezprofila') {
    _prva_rec = "PANEL BEZ PROFILA ";
  }
  let _treca_rec = "";
  if (p.revizioniotvor === "DA") {
    _treca_rec = " SA REVIZIJOM";
  }
  let I14 = _prva_rec + TIPPANELA + _treca_rec + " " + sirina + "x" + visina + " " + "R";
  if (p.tippanela === 'panelbezprofila') {
    I14 = _prva_rec + " " + sirina + "x" + visina + " " + "R";
  }
  // I14 += XIF(I5 === "kamenavuna", "W", XIF(I5 === "poliuretan", "P", "?"));
  /*
  console.log('ATEEESt', I3, I4);
  if (I3 !== 'HYGIENE:pro') {
    console.log('ATEEESt u prvu');
    I14 += 'R';
  } else if (I3 === 'HYGIENE:pro' && I4 === "prohrom") {
    console.log('ATEEESt drugu')
    I14 += 'S';
  } else if (I3 === 'HYGIENE:pro' && I4 === "plastificirano" && tippanela === "podni") {
    I14 += 'S';
  } else {
    I14 += 'R';
  };
  */
  let _slovo1 = 'R';
  let _slovo2 = "?";
  if (I5 === "kamenavuna") {
    _slovo2 = "W";
  }
  if (I5 === "poliuretan") {
    _slovo2 = "P";
  }
  let _slovo3 = "R";
  if (I3 === "HYGIENE:pro") {
    console.log("+++++ !", I3)
    console.log(I4, unutrasnjaoplata)
    console.log("+++++ HYGIENE:pro")
    console.log(I4, unutrasnjaoplata)
    if (I4 === "prohrom") {
      _slovo3 = "S";
    }
  }
  I14 += _slovo2 + _slovo3;
  I14 += XIF(I7 === "DA", " K", "") + XIF(I8 === "DA", " SB", "");
  return I14;
};


// NE KORISTI SE
export const derivatPoluproizvod_panel_dopuni = (p, k) => {
  // SPECIJALNI KORAK
  // Panelu dodajemo neke podatke iz klima komore koji su mu potrebni!

  let panel = {};
  if (p.tippanela === 'vrata') {
    panel = {
      ...p,
      ..._getParamsFromLib("terkk$panel_tip_vrata")
    };
  } else {
    panel = {
      ...p,
      ..._getParamsFromLib("terkk$panel_tip_not_vrata")
    };
  }

  // unutrasnja oplata je po defaultu plastificirano
  //a ako je komora higijenik, onda se bira unutrasnja oplata
  panel.tipkomore = k.tipkomore;
  if (k.tipkomore === 'HYGIENE:pro') {
    panel.unutrasnjaoplata = k.unutrasnjaoplata;
  } else {
    // panel.unutrasnjaoplata = '';
    panel.unutrasnjaoplata = 'plastificirano';
  };
  console.log(k);
  console.log(panel);

  if (panel.tippanela === 'panelizmenjivaca') {
    let panelIzmenjivacaDodatniPodaci = derivatZaPanelIzmenjivaca(panel);
    panel = {
      ...panel,
      ...panelIzmenjivacaDodatniPodaci
    };
  };

  if (k.tipispuneklimakomore) {
    panel.tipispuneklimakomore = k.tipispuneklimakomore;
  };

  if (panel._subform_arr && Array.isArray(panel._subform_arr)) {
    panel._subform_arr.forEach((panelEl) => {
      panelEl.calculated_ident = terUtilsGetIdentPanel(panelEl);
    });
  };

  panel.naziv = _derivatPoluproizvod_panel_naziv(p, k.tipkomore, panel.unutrasnjaoplata, k.tipispuneklimakomore, true);

  return panel;
};


//
export const derivatPoluproizvod_panel_izracunaj_rucicarukohvat_kolicina = (_sirina, _visina) => {
  // 2 komada ukoliko je jedna od stranica >1000 ukoliko nemamo stranicu >1000 onda 1 komad.
  let panel_rucicarukohvat_kolicina_preporucena = null;
  if (_sirina > 1000 || _visina > 1000) {
    panel_rucicarukohvat_kolicina_preporucena = 2;
  } else {
    panel_rucicarukohvat_kolicina_preporucena = 1;
  }
  return panel_rucicarukohvat_kolicina_preporucena;
}


export const derAutoCreateVirbom_terkk_panel_prepare_vir_input = (p) => {

  const I2 = p.sistempanela;
  const I3 = p.tipkomore; // tip komore
  let I4 = 'plastificirano'; // unutrasnja oplata je po defaultu plastificirano
  // a ako je komora higijenik, onda se bira unutrasnja oplata
  if (p.unutrasnjaoplata) {
    I4 = p.unutrasnjaoplata; // unutrasnja oplata
  };
  // const I5 = p.ispuna; // moram da ubacim u definiciju
  const I5 = p.tipispuneklimakomore;
  const tippanela = p.tippanela;
  // const I7 = "DA"; // KLJUC ???
  const I7 = p.kljuc; // KLJUC ???
  // const I8 = "DA"; // Sigurnosna brava ???
  const I8 = p.sigurnosnabrava; // Sigurnosna brava ???
  const sirina = p.sirina;
  const visina = p.visina;

  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  let v_input = {
    sistempanela: I2,
    tipkomore: I3,
    unutrasnjaoplata: I4,
    tipispuneklimakomore: I5,
    vrstaprofila: p.vrstaprofila,
    tippanela: tippanela,
    kljuc: I7,
    sigurnosnabrava: I8,
    revizioniotvor: p.revizioniotvor,
    sirina: sirina,
    visina: visina,
    panelkolicina: p.kolicina,
    naziv_panela: p.naziv,
    panel_lim_spoljasnji_tip: p.panel_lim_spoljasnji_tip,
    panel_lim_unutrasnji_tip: p.panel_lim_unutrasnji_tip,
    _KOMPLETAN_panel: p
  };
  if (v_input.kljuc !== "DA") {
    v_input.kljuc = "NE"; // FIX jer excel formule traze explicitno da bude "NE" ukoliko nije "DA".
  }
  return v_input;
};


export const derAutoCreateVirbom_terkk_panel_children = (v_input) => {
  console.log('derAutoCreateVirbom_terkk_panel_children(v_input)');
  console.log(v_input);
  // NOVI SISTEM
  let z = {}; // rezultat
  let _ix = {}; // JOCKER promenjiva pre x IZUZETAK
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;
  let _kolicina;
  let _kolicina_poslednje_op;
  let _level1_counter = 0;
  let _level1vrata_counter = 0;
  let _izuzetak = ''; // ???
  let _ukupna_kolicina_rucica_sa_i_bez_kljuca = 0;

  let der_key;
  let materijal_key;

  //
  let _materijal_ident;

  //
  let unutrasnjaoplata = v_input.unutrasnjaoplata;
  let tipkomore = v_input.tipkomore;

  const I2 = v_input.sistempanela;
  const I3 = v_input.tipkomore; // tip komore
  let I4 = 'plastificirano'; // unutrasnja oplata je po defaultu plastificirano
  //a ako je komora higijenik, onda se bira unutrasnja oplata
  if (v_input.unutrasnjaoplata) {
    I4 = v_input.unutrasnjaoplata; // unutrasnja oplata
  };
  // const I5 = p.ispuna; // moram da ubacim u definiciju
  const I5 = v_input.tipispuneklimakomore;
  const tippanela = v_input.tippanela;
  // const I7 = "DA"; // KLJUC
  const I7 = v_input.kljuc; // KLJUC ???
  // const I8 = "DA"; // Sigurnosna brava
  const I8 = v_input.sigurnosnabrava; // Sigurnosna brava
  const sirina = v_input.sirina; // I9
  const visina = v_input.visina; // I10
  const panelkolicina = v_input.panelkolicina; //

  const H14 = 'PAN00000';
  // const I14 = "PANEL " + tippanela.toUpperCase() + " " + sirina + "x" + visina + " " + "R" + XIF(I5 === "kamenavuna", "W", XIF(I5 === "poliuretan", "P", "?")) + XIF(AND(I3 === "HIGIJENIK", tippanela === "podni"), "S", XIF(I4 === "plastificirano", "R", XIF(I4 === "prohrom", "S", "?")) + XIF(I7 === "DA", " K", "") + XIF(I8 === "DA", " SB", ""));
  // const I14 = _derivatPoluproizvod_panel_naziv(v_input._KOMPLETAN_panel, v_input.tipkomore, v_input.unutrasnjaoplata, v_input.tipispuneklimakomore, false);
  // const I14 = v_input.naziv_panela;
  const _panel_naziv_redovni = _derivatPoluproizvod_panel_naziv(v_input._KOMPLETAN_panel, v_input.tipkomore, v_input.unutrasnjaoplata, v_input.tipispuneklimakomore, false);
  const I14 = _panel_naziv_redovni;


  // Prve cetiri stavke, dervat local 1,2,3,4 uvek se automatski kreiraju.


  /*
  ? ide na prvo na prvo mesto. A drugi ide koja GRCPANKK, 
  dakle samo da zamenimo operaciju za njih dva...
  
  prvi je zadnja oparcija .a zadnja operaciaj je ugradnja rucica i sarki i ostalo u panel....
  **** radnici najpre uzmu vuni i profile i naprave panel
  zatim idu u drugu operaciju na sklopljen panel dodaju rucicu i sarke, revizione otvore i dobiju gotov panel vrata
  
  */


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  let _panel_vrata_graphlevel;
  let _panel_not_vrata_graphlevel;

  let _slucaj_vrata_ili_sarevizionim = false;
  if (tippanela === 'vrata' || v_input.revizioniotvor === "DA") {
    _slucaj_vrata_ili_sarevizionim = true;
  }

  let _panel_ima_profile = true;
  let _panel_ima_ojacanja = true;
  if (tippanela === 'panelbezprofila') {
    _panel_ima_profile = false;
    _panel_ima_ojacanja = false;
  }


  // stavka IZUZETAK MINUS 1 KADA SU U PITANJU tippanela vrata ili kada panel ima revizioniotvor === "DA"
  // derivat local 1 (MINUS 1) PANEL OPERACIJA PRE VRATA NA TOP LEVEL VIRTELU
  console.log('_izuzetak', _izuzetak);
  // if (tippanela === 'vrata') {
  if (tippanela === 'vrata' || v_input.revizioniotvor === "DA") { // ako je vrata ili ako ima revizioni otvor
    _derivat_key = 'izuzetak_minus_1';
    console.log('_izuzetak VRATA', _izuzetak);
    let _kopirani_parametri_panela = _terkk_panel_multiflag_tippanela_helper(v_input._KOMPLETAN_panel);  // BUDZENJE PRIVREMENO
    delete _kopirani_parametri_panela.kljuc;
    delete _kopirani_parametri_panela.sigurnosnabrava;
    _ix = {
      ..._kopirani_parametri_panela,
      _derivat_key,
      virtelschemakey: 'terkk$panel',
      virtelclass: "terkk$panel_tip_vrata$op_pre_vrata",
      // tergrupa: 'PANEL',
      // terkategorija: 'PP',
      // tippanela: "panelvrata",
      tipispuneklimakomore: v_input.tipispuneklimakomore,
      panel_lim_spoljasnji_tip: v_input.panel_lim_spoljasnji_tip,
      panel_lim_unutrasnji_tip: v_input.panel_lim_unutrasnji_tip
    };
    if (tippanela === 'vrata') {
      _ix.tippanela = "panelvrata";
      // _ix.naziv = v_input.naziv_panela; // naziv za panel operacija pre vrata je isti kao naziv panela
      // DL 2020-08-24: Za prvi podnivo (tamo gde je Radni centar "GRC-Paneli KK") ostaviti naziv "PANEL VRATA 701x801 RWR K SB"
      _ix.naziv = "PANEL " + v_input.naziv_panela; // BUDZENJE NOVO dodajemo prefix "PANEL " za naziv kod operacije pre vrata
    } else if (tippanela === 'opsluzioni') { // NJ 2024-10-24: Opsluzioni panel operacija pre vrata da tip bude "panelopsluzioni"
      _ix.tippanela = "panelopsluzioni";
      _ix.naziv = v_input.naziv_panela;
    } else {
      _ix.tippanela = v_input.tippanela;
      // kada nisu vrata ali panel ima revizioniotvor === "DA" tada je naziv opereacije pre vrata isti kao naziv panela sa top level virtela
      _ix.naziv = v_input.naziv_panela;
    }
    // _ix.kolicina = panelkolicina;
    _ix.kolicina = SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    _ix = {
      ..._ix,
      ..._getParamsFromLib("terkk$panel_tip_vrata$op_pre_vrata")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = _ix;
    _virbom_manipulator.add_as_first_virtel(virbom_ref, _ix);
  }
  console.log('_derivat_key', _derivat_key);
  console.log('_ix', _ix);
  if (tippanela === 'vrata' || v_input.revizioniotvor === "DA") {
    _panel_not_vrata_graphlevel = 2;
  } else {
    _panel_not_vrata_graphlevel = 1;
  }


  if (_panel_ima_profile === true) {
    //
    // stavka 1 PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA
    // derivat local 1
    _derivat_key = 'profil1';
    x = {
      virtelschemakey: 'terkk$panel$derivat1',
      virtelclass: "terkk$panel$profil",
      kolicina: 2,
      // tergrupa: 'PROFIL',
      sirinarazvijena: ''
    };
    // x.calculated_ident = XIF(I2 === "starisistem", "P46TVCA00000", XIF(I2 === "novisistem", "PTVK2CAAR0B0", "?"));
    // x.naziv = XIF(H15 === "P46TVCA00000", "PROFIL PVC 46TV-K 46TV SIROV", XIF(H15 === "PTVK2CAAR0B0", "PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA", "?"));
    x.duzina = sirina;
    // x.leviger = 45;
    // x.desniger = 45;
    //
    x.calculated_ident = 'PROF0001';
    _materijal_ident = XIF(I2 === "starisistem", "P46TVCA00000", XIF(I2 === "novisistem", "PTVK2CAAR0B0", "?"));
    const H15 = _materijal_ident;
    x.naziv = XIF(H15 === "P46TVCA00000", "PROFIL PVC 46TV-K 46TV SIROV", XIF(H15 === "PTVK2CAAR0B0", "PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA", "?"));
    _materijal_naziv = x.naziv;
    x._materijal_naziv = x.naziv;
    x.naziv = _materijal_naziv + ' ' + x.duzina + 'mm';
    x.tip = XIF(I2 === "starisistem", "P46TVCA00000", XIF(I2 === "novisistem", "PTVK2CAAR0B0", "?"));
    x = {
      ...x,
      ..._getParamsFromLib("terkk$panel$profil")
    }; // parametri na kraju imaju prioritet
    z['profil1'] = x;
    console.log(_derivat_key, _izuzetak);
    console.log(x);
    /*
    // if (tippanela === 'vrata') {
    if (tippanela === 'vrata' || v_input.revizioniotvor === "DA") {
      _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);
      _panel_not_vrata_graphlevel = 2;
    } else {
      _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
      _panel_not_vrata_graphlevel = 1;
    }
    */
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);


    // derivat local 1.1 
    // der_key = 'profil1';
    materijal_key = _derivat_key + '_m';
    _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
    xm = {
      ..._mat,
      _derivat_key: materijal_key,
      virtelschemakey: 'terkk$panel$materijal1',
    };
    z[materijal_key] = xm;
    console.log('_izuzetak 1 xm', _izuzetak);
    console.log(xm);
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


    // stavka 2 PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA
    // derivat local 2 PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA
    _derivat_key = 'profil2';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$derivat1',
      virtelclass: "terkk$panel$profil",
      kolicina: 2,
      // tergrupa: 'PROFIL',
      sirinarazvijena: ''
    };
    x.calculated_ident = XIF(I2 === "starisistem", "P46TVCA00000", XIF(I2 === "novisistem", "PTVK2CAAR0B0", "?"));
    const H16 = x.calculated_ident;
    x.naziv = XIF(H16 === "P46TVCA00000", "PROFIL PVC 46TV-K 46TV SIROV", XIF(H16 === "PTVK2CAAR0B0", "PROFIL PVC KK PANELA 2.0 TVK2 SIROV CRNA", "?"));
    x.duzina = visina;
    x.leviger = 45;
    x.desniger = 45;
    x.tip = XIF(I2 === "starisistem", "P46TVCA00000", XIF(I2 === "novisistem", "PTVK2CAAR0B0", "?"));
    _materijal_naziv = x.naziv;
    x._materijal_naziv = x.naziv;
    x.naziv = _materijal_naziv + ' ' + x.duzina + 'mm';
    x.tip = 'PTVK2CAAR0B0';
    x = {
      ...x,
      ..._getParamsFromLib("terkk$panel$profil")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    console.log('_izuzetak 2 x', _izuzetak);
    console.log(x);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);


    // derivat local 2.1
    // der_key = "profil2";
    materijal_key = _derivat_key + '_m';
    _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
    xm = {
      ..._mat,
      _derivat_key: materijal_key,
      virtelschemakey: 'terkk$panel$materijal1',
    };
    z[materijal_key] = xm;
    console.log('_izuzetak 2 xm', _izuzetak);
    console.log(xm);
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
    //
  } // kraj if _panel_ima_profile


  // SPOLJASNJI LIM
  // stavka 3 PANEL STANDARDNI 602x1202 RWR K SB SPOLJASNJI LIM
  // derivat local 3
  // S4+P4 operacija 2. OPERACIJA SAVIJANJA ZA SPOLJASNJI LIM
  _derivat_key = 'derivat_pp_lim_spolj';
  let _kopirani_parametri_panela = _terkk_panel_multiflag_tippanela_helper(v_input._KOMPLETAN_panel);  // BUDZENJE PRIVREMENO
  delete _kopirani_parametri_panela.kolicina;
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$panel$derivat1',
    // virtelclass: "terkk$panel$lim_spoljasnji",
    virtelclass: "terkk$panel$lim_spoljasnji_opsav", // OPERACIJA SAVIJANJA ZA SPOLJASNJI LIM
    ..._kopirani_parametri_panela,
    sirinarazvijena: '',
    duzina: '',
    panel_lim_spoljasnji_tip: v_input.panel_lim_spoljasnji_tip,
    panel_lim_unutrasnji_tip: null,
  };
  x.calculated_ident = XIF(I2 === "starisistem", "", XIF(I2 === "novisistem", (H14 + "SL"), "?"));
  const H18 = x.calculated_ident;
  x.naziv = XIF(H18 === "", "", XIF(I2 === "novisistem", (I14 + " SPOLJASNJI LIM"), "?"));
  // x.kolicina = XIF(H18 === "", "", XIF(I2 === "novisistem", 1, "?"));
  _kolicina_poslednje_op = XIF(H18 === "", "", XIF(I2 === "novisistem", 1, "?"));
  x.kolicina = _kolicina_poslednje_op;
  x.sirina = sirina; // dimenzija lima su za sada identicne kao panela
  x.visina = visina; // dimenzija lima su za sada identicne kao panela
  // const _der_lim_spolj = _derivat_panel_lim_spoljasnji();
  const _der_lim_spolj = _derivat_panel_lim_spoljasnji(v_input._KOMPLETAN_panel); // NOVO 2024-01-22
  x.tip = _der_lim_spolj.tip;
  x.termaterijal = _der_lim_spolj.tip;
  x.cncprogram1 = _derivat_panel_lim_cncprogram(true, tippanela);
  // x.tip = "SPOLJASNJI";
  x._materijal_naziv = _der_lim_spolj._materijal_naziv;
  x = {
    ...x,
    // ..._getParamsFromLib("terkk$panel$lim_spoljasnji")
    ..._getParamsFromLib("terkk$panel$lim_spoljasnji_opsav"),
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  // _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
  //
  // NJ 2024-07-26: NOVI ZAHTEV: panel lim spoljašnji ne treba mu operacija savijanja, on je vec gotov na operaciji secenja, izuzev u slucaju panel tip vrata jer onda mu treba i operacija secenja i operacija savijanja.
  if (tippanela === 'vrata' || tippanela === 'panelbezprofila') { // obe operacija. prvo secenje pa savijanje.
    // CASE tippanela === 'vrata'
    //
    // S4+P4 operacija 2. OPERACIJA SAVIJANJA ZA SPOLJASNJI LIM
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
    //
    // S4+P4 operacija 1. OPERACIJA SECENJA ZA SPOLJASNJI LIM
    x = {
      ...x,
      virtelclass: "terkk$panel$lim_spoljasnji_opsec", // OPERACIJA SECENJA ZA SPOLJASNJI LIM
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._getParamsFromLib("terkk$panel$lim_spoljasnji_opsec"),
    };
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);
  } else { // samo jedna operacija secenje
    //
    // S4+P4 operacija 1. OPERACIJA SECENJA ZA SPOLJASNJI LIM
    x = {
      ...x,
      virtelclass: "terkk$panel$lim_spoljasnji_opsec", // OPERACIJA SECENJA ZA SPOLJASNJI LIM
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._getParamsFromLib("terkk$panel$lim_spoljasnji_opsec"),
    };
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
  }
  console.log('derivat_pp_lim_spolj x', x);


  // derivat local 3.1
  // _derivat_key = 'derivat_pp_lim_spolj';
  materijal_key = _derivat_key + '_m';
  _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
  xm = {
    ..._mat,
    _derivat_key: materijal_key,
    virtelschemakey: 'terkk$panel$materijal1',
    virtelclass: 'terkk$_grupa_lim.1_materijal'
  };
  z[materijal_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
  console.log('derivat_pp_lim_spolj xm', xm);
  console.log('z', z);


  // UNUTRSNJI LIM
  // stavka 4 PANEL STANDARDNI 602x1202 RWR K SB UNUTRSNJI LIM
  // derivat local 4
  // S4+P4 operacija 2.
  _derivat_key = 'derivat_pp_lim_unutr';
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$panel$derivat1',
    // virtelclass: "terkk$panel$lim_unutrasnji",
    virtelclass: "terkk$panel$lim_unutrasnji_opsav",
    ..._kopirani_parametri_panela,
    sirinarazvijena: '',
    duzina: '',
    leviger: '',
    desniger: '',
    panel_lim_spoljasnji_tip: null,
    panel_lim_unutrasnji_tip: v_input.panel_lim_unutrasnji_tip
  };
  x.calculated_ident = XIF(I2 === "starisistem", "", XIF(I2 === "novisistem", (H14 + "UL"), "?"));
  const H19 = x.calculated_ident;
  x.naziv = XIF(H19 === "", "", XIF(I2 === "novisistem", (I14 + " UNUTRASNJI LIM"), "?"));
  if (unutrasnjaoplata === 'prohrom') {
    // ???
  }
  // x.kolicina = XIF(H18 === "", "", XIF(I2 === "novisistem", 1, "?"));
  _kolicina_poslednje_op = XIF(H18 === "", "", XIF(I2 === "novisistem", 1, "?"));
  x.kolicina = _kolicina_poslednje_op;
  x.sirina = sirina; // dimenzija lima su za sada identicne kao panela
  x.visina = visina; // dimenzija lima su za sada identicne kao panela
  x.jm = tclocal.JM_KOM; // Proveriti formulu u Excelu
  // const _der_lim_unutr = _derivat_panel_lim_unutrasnji(tippanela, tipkomore, unutrasnjaoplata);
  const _der_lim_unutr = _derivat_panel_lim_unutrasnji(v_input._KOMPLETAN_panel); // NOVO 2024-01-22
  x.tip = _der_lim_unutr.tip;
  x.termaterijal = _der_lim_unutr.tip;
  // x.tip = "UNUTRASNJI";
  x._materijal_naziv = _der_lim_unutr._materijal_naziv;
  x.cncprogram1 = _derivat_panel_lim_cncprogram(false, tippanela);
  x = {
    ...x,
    // ..._getParamsFromLib("terkk$panel$lim_unutrasnji")
    ..._getParamsFromLib("terkk$panel$lim_unutrasnji_opsav"),
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);

  // S4+P4 operacija 1.
  x = {
    ...x,
    virtelclass: "terkk$panel$lim_unutrasnji_opsec",
    kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
    ..._getParamsFromLib("terkk$panel$lim_unutrasnji_opsec"),
  };
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);


  // derivat local 4.1
  // _derivat_key = 'derivat_pp_lim_unutr';
  materijal_key = _derivat_key + '_m';
  _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
  xm = {
    ..._mat,
    _derivat_key: materijal_key,
    virtelschemakey: 'terkk$panel$materijal1',
    virtelclass: 'terkk$_grupa_lim.1_materijal'
  };
  z[materijal_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // stavka 5 OJACANJE PANELA 592mm
  // Ova stavka ne ide uvek. Zavisi od dimenzija i tipa panela.
  // derivat local 5
  // S4+P4 operacija 2.
  _derivat_key = "derivat_pp_ojacanje";
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$panel$derivat1',
    // TODO+
    // virtelclass: "terkk$panel$ojacanje",
    virtelclass: "terkk$panel$ojacanje_opsav",
    cncprogram1: "Lim AHU Panel Ojacanje.S4",
  };
  x.calculated_ident = 'OJA000001';
  // Racunam atribute ojacanja
  let ojacanje = _izracunaj_ojacanja_NoviSistem(sirina, visina, tippanela, v_input.revizioniotvor);
  console.log('ojacanje');
  console.log(ojacanje);
  x.duzina = ojacanje.duzinaOjacanja; // Treba da se izracuna automatski
  x.sirina = ojacanje.sirinaOjacanja; // Uvek je konstantna 125. Ovo je sirina kad je savijen lim
  x.sirinarazvijena = x.sirina + 123.38;
  x.kolicina = ojacanje.brojKomadaOjacanja; // Treba da se izracuna automatski! To je u sastavnici kolona kolicina!
  x.naziv = 'OJACANJE PANELA ' + x.duzina + 'mm';
  // x.tip = 'STANDARDNI';
  x.tip = '?';
  //
  // _materijal_naziv = 'naziv lima';
  // Sad za ojacanja stavimo koji je LIM, ako postoji ojacanje
  // Ako nije podni onda bude spoljasnji lim, ako je podni bude unutrasnji lim od podnog panela
  x._materijal_naziv = 'naziv lima';
  if (v_input.tippanela === 'podni') {
    // ako je podni bude unutrasnji lim od podnog panela
    x._materijal_naziv = z['derivat_pp_lim_unutr']._materijal_naziv;
    x.tip = z['derivat_pp_lim_unutr'].tip;
    x.termaterijal = z['derivat_pp_lim_unutr'].termaterijal;
  } else {
    // Ako nije podni onda bude spoljasnji lim
    x._materijal_naziv = z['derivat_pp_lim_spolj']._materijal_naziv;
    x.tip = z['derivat_pp_lim_spolj'].tip;
    x.termaterijal = z['derivat_pp_lim_spolj'].termaterijal;
  }
  x = {
    ...x,
    // ..._getParamsFromLib("terkk$panel$ojacanje"),
    ..._getParamsFromLib("terkk$panel$ojacanje_opsav"),
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;


  // Ukoliko je kolicina 0, brisemo ojacanje.
  if (!ojacanje.brojKomadaOjacanja || ojacanje.brojKomadaOjacanja === 0) {
    // Ukoliko je kolicina 0, brisemo ojacanje.
    delete z['derivat_pp_ojacanje'];
    // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj element
  } else if (tippanela !== 'opsluzioni' && tippanela !== 'standardni' && tippanela !== 'podni') {
    // Ukoliko tippanela nije ni opsluzioni ni standardni ni podni brisemo ojacanje
    delete z['derivat_pp_ojacanje'];
    // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj element
  } else {
    // u slucaju da dodajemo ojacanje
    // S4+P4 operacija 2.
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
    // S4+P4 operacija 1.
    x = {
      ...x,
      virtelclass: "terkk$panel$ojacanje_opsec",
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      ..._getParamsFromLib("terkk$panel$ojacanje_opsec"),
    };
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, x);
    // ako ostaje (ne brisemo ga) poluproizvod onda ide i njegov materijal
    // derivat local 5.1
    // _derivat_key = 'derivat_pp_ojacanje';
    materijal_key = _derivat_key + '_m';
    _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
    xm = {
      ..._mat,
      _derivat_key: materijal_key,
      virtelschemakey: 'terkk$panel$materijal1',
      virtelclass: 'terkk$_grupa_lim.1_materijal'
    };
    z[materijal_key] = xm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
  }


  // stavka 6. KAMENA VUNA
  // derivat local 6
  let derivatiKamenaVuna = derivatPoluproizvodPanel_KamenaVunaNoviSistem_virtel(sirina, visina, ojacanje, I2, I5, tippanela);
  if (derivatiKamenaVuna['kamenavuna1']) {
    _derivat_key = 'kamenavuna1';
    x = {
      _derivat_key,
      ...derivatiKamenaVuna['kamenavuna1'],
      virtelschemakey: 'terkk$panel$derivat1',
      virtelclass: "terkk$panel$ispuna",
    };
    x = {
      ...x,
      multitranslator_lang: "terkk$grupa_ispuna/grupa_ispuna",
      ..._getParamsFromLib("terkk$panel$ispuna")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    console.log('*** kamenavuna1');
    console.log(z['kamenavuna1']);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);


    // derivat local 6.1
    // _derivat_key = 'kamenavuna1';
    materijal_key = _derivat_key + '_m';
    _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
    xm = {
      ..._mat,
      _derivat_key: materijal_key,
      virtelschemakey: 'terkk$panel$materijal1',
    };
    z[materijal_key] = xm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


    if (derivatiKamenaVuna['kamenavuna2']) {
      // derivat local 6b ???
      _derivat_key = 'kamenavuna2';
      x = {
        _derivat_key,
        ...derivatiKamenaVuna['kamenavuna2'],
        virtelschemakey: 'terkk$panel$derivat1',
        virtelclass: "terkk$panel$ispuna",
      };
      x = {
        ...x,
        multitranslator_lang: "terkk$grupa_ispuna/grupa_ispuna",
        ..._getParamsFromLib("terkk$panel$ispuna")
      }; // parametri na kraju imaju prioritet
      z[_derivat_key] = x;
      console.log('*** kamenavuna2');
      console.log(z['kamenavuna2']);
      _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);


      // derivat local 6b.1
      // _derivat_key = 'kamenavuna2';
      materijal_key = _derivat_key + '_m';
      _mat = _derivat_panel_materijal1_by_pp(x, _derivat_key, tippanela);
      xm = {
        ..._mat,
        _derivat_key: materijal_key,
        virtelschemakey: 'terkk$panel$materijal1',
      };
      z[materijal_key] = xm;
      _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);
    }
  }


  // STAVKE OD 7 PA NADALJE SU MATERIJALI


  if (tippanela !== "panelbezprofila") { // NJ 2024-12-04: Za panelbezprofila panele nije potrebna zaptivna traka
    // stavka 7 M-Materijal TRAKA ZAPTIVNA AROSIO 20X4
    // ili stavka 8 TRAKA ZAPTIVNA AROSIO EVA 20X6
    // derivat local 7
    // ili derivat local 8
    // Zavisno od ispunjenih uslova ide jedna ili druga stavka
    _derivat_key = 'derivat_m_traka';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_M
    };
    /*
    x.calculated_ident = XIF(tippanela === "vrata", "A040000000000025", "A040000000000030");
    const H27 = x.calculated_ident;
    x.naziv = XIF(H27 === "A040000000000025", "TRAKA ZAPTIVNA AROSIO EVA 20X6", XIF(H27 === "A040000000000030", "TRAKA ZAPTIVNA AROSIO 20X4"));
    */
    // 2023-11-23 Tiket: Prepravka idenata za Arosio traku #182
    if (tippanela === "vrata" || tippanela === "opsluzioni") {
      const tervrstaprofila_50_ili_70 = _derivatModulProfil_extract_50_ili_70_by_vrstaprofila(v_input.vrstaprofila);
      if (tervrstaprofila_50_ili_70 === '50') {
        // profil 50
        x.calculated_ident = "A040000000000030";
        x.naziv = "TRAKA ZAPTIVNA AROSIO EVA 20X4";
      } else if (tervrstaprofila_50_ili_70 === '70') {
        // profil 70
        x.calculated_ident = "A040000000000025";
        x.naziv = "TRAKA ZAPTIVNA AROSIO EVA 20X6";
      }
    } else {
      // x.calculated_ident = "A040000000000009";
      // x.naziv = "TRAKA ZAPTIVNA AROSIO 20X4";
      // NJ 2025-02-11: Potrebno je umesto trake sa identom A040000000000009 TRAKA ZAPTIVNA AROSIO 20X4 koristiti traku sa identom A040000000000030 TRAKA ZAPTIVNA AROSIO EVA 20X4
      x.calculated_ident = "A040000000000030";
      x.naziv = "TRAKA ZAPTIVNA AROSIO EVA 20X4";
    }
    //
    _kolicina = (sirina * 2) + (visina * 2);
    x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3);
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
    //
  }


  // derivat local 16
  _derivat_key = 'derivat_m_lepak';
  x = {
    _derivat_key,
    virtelschemakey: 'terkk$panel$materijal2',
    // virtelclass: "terkk$panel$sigurnosnabrava",
    terkategorija: 'M',
    jm: tclocal.JM_KOM
  };
  x.calculated_ident = 'A050020000000009';
  x.naziv = 'LEPAK ZA PANELE KK (500g)';
  const povrsina_panela = (v_input.sirina * v_input.visina) / 1000000; // delimo sa milion da obijemo m2
  x.kolicina = terUtilsNumberRoundUp((povrsina_panela * 0.32), 2); // zaokruzujemo na 2 decimale ROUNDUP.
  x = {
    ...x,
    // ..._getParamsFromLib("terkk$panel$sigurnosnabrava")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  // _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
  _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);


  // stavka 9 M-Materijal OSTALO REVIZIONI OTVOR W 39-53
  // Ova stavka ide samo kada je izabrana REVIZIJA: DA.
  // derivat 1, u excelu 6 Ovo radimo samo ako su vrata sa revizijom
  if (v_input.revizioniotvor === "DA") {
    // derivat local 9
    _derivat_key = 'derivat_m_revizioni';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = 'B100010000000049';
    const H20 = x.calculated_ident;
    x.naziv = 'OSTALO REVIZIONI OTVOR W 39-53';
    x.kolicina = 1;
    z[_derivat_key] = x;
    // _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, 1); // DL 2024-03-06: Potrebno je materijal B100010000000049 - OSTALO REVIZIONI OTVOR W 39-53 bude umesto u poluproizvod panel vrata (terkk$panel_tip_vrata$op_pre_vrata) da bude u vratima (terkk$panel_tip_vrata)
    // DL 2024-04-08: razjašnjenje: materijal revizioni otvor se troši na poslednjoj operacji gde se sklapaju vrata. Dakle čak i kada nije u pitanju tip vrata ali ima revizioni otvor na kraju ima još jednu operaciju ugradnje revizionog otvora koja se vrši isto tamo gde se sklapaju vrata.
  }



  // stavke 10-14 imaju veze sa vratima
  // derivat local 10 RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS
  // derivat local 11 RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS
  // derivat local 12 RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS
  // derivat local 13 RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS
  // derivat local 14 ŠARKA PVC KLIMAFLEX 325070 INDUSTRILAS
  if (v_input.tippanela === 'vrata') {
    // stavka 10 M-Materijal RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS
    // derivat 2, u excelu 7
    // derivat local 10
    _derivat_key = "derivat_m_rucica_bez_kljuca";
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      terkategorija: 'M',
      virtelclass: "terkk$panel$panel_novo_rucica_m",
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = XIF(tippanela === "vrata", "B080010000000004", "");
    x.naziv = 'RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS';
    x.kolicina = XIF(AND(tippanela === "vrata", I7 === "NE"), XIF(visina > 1300, 4, XIF(visina > 800, 3, XIF(visina > 500, 2, 1))), XIF(AND(tippanela === "vrata", I7 === "DA"), XIF(visina > 1300, 3, XIF(visina > 800, 2, XIF(visina > 500, 1, 0))))); // izracunavmo kolicinu rucica bez kljuca
    x = {
      ...x,
      ..._getParamsFromLib("terkk$panel$panel_novo_rucica_m")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x; // rucica BEZ KLJUCA

    // Ako je broj komada za ovaj element 0 onda izbrisi ovaj derivat
    if (z[_derivat_key].kolicina === 0) {
      // brisemo jer je kolicina 0
      delete z[_derivat_key];
      // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj element
    } else {
      // dodajemo jer je količina više od 0
      _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    }


    // stavka 11 M-Materijal RUČICA PVC KLIMAFLEX 2 2651-215690 INDUSTRILAS SA KLJUCEM
    // derivat 3, u excelu 8 Ovo radimo samo ako je kljuc DA
    if (v_input.kljuc === "DA") {
      // CASE znaci da je jedna od rucica sa kljucem.
      // derivat local 11
      // _level1_counter++;
      _derivat_key = 'derivat_m_rucica_sa_kljucem';
      x = {
        _derivat_key,
        virtelschemakey: 'terkk$panel$materijal2',
        terkategorija: 'M',
        virtelclass: "terkk$panel$panel_novo_rucica_m",
        jm: tclocal.JM_KOM
      };
      // x.calculated_ident = 'B080010000000008';
      x.calculated_ident = 'B080010000000014'; // NJ 2024-10-08: Dodao sam novi ident ručice sa ključem B080010000000014. Potrebno je na vratima, dodati umesto postojećeg identa ručice sa ključem.
      x.naziv = 'RUČICA PVC KLIMAFLEX 2 2651-215690 INDUSTRILAS SA KLJUCEM';
      x.kolicina = SINGLE_PIECE; // DL 2023-09-01: ako ima kljuc onda je kolicina samo JEDNA rucica sa kljucem. Nikada ne može da bude više od jedne ručice sa ključem. Može samo da bude jedna ili da je nema uopšte.
      x = {
        ...x,
        ..._getParamsFromLib("terkk$panel$panel_novo_rucica_m")
      }; // parametri na kraju imaju prioritet
      z[_derivat_key] = x; // rucica SA KLJUCEM
      _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    }


    // nakon rucica sa i bez ključa, izracunavamo ukupnu kolicinu rucica
    if (z['derivat_m_rucica_bez_kljuca'] && z['derivat_m_rucica_bez_kljuca'].kolicina > 0) {
      _ukupna_kolicina_rucica_sa_i_bez_kljuca += z['derivat_m_rucica_bez_kljuca'].kolicina;
    };
    if (z['derivat_m_rucica_sa_kljucem'] && z['derivat_m_rucica_sa_kljucem'].kolicina > 0) {
      _ukupna_kolicina_rucica_sa_i_bez_kljuca += z['derivat_m_rucica_sa_kljucem'].kolicina;
    };


    // stavka 12 M-Materijal RUČICA NOSAC PVC KLIMAFLEX 2 2651-101045 INDUSTRILAS
    // derivat 4, u excelu 9
    // derivat local 12
    _derivat_key = 'derivat_m_rucica_dodatak1';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      virtelclass: "terkk$panel$panel_novo_rucica_m",
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = 'B080010000000002';
    const H23 = x.calculated_ident;
    x.naziv = 'RUČICA NOSAC PVC KLIMAFLEX 2 2651-101045 INDUSTRILAS';
    // x.kolicina = XIF(H23 === "", "", XIF(tippanela === "vrata", XIF(visina > 1300, 4, XIF(visina > 800, 3, XIF(visina > 500, 2, "1")))));
    x.kolicina = _ukupna_kolicina_rucica_sa_i_bez_kljuca;
    x = {
      ...x,
      ..._getParamsFromLib("terkk$panel$panel_novo_rucica_m")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // stavka 13 M-Materijal RUČICA ROLER PVC KLIMAFLEX 2 2651-305125-0062 INDUSTRILAS
    // derivat 5, u excelu 10
    // derivat local 13
    _derivat_key = 'derivat_m_rucica_dodatak2';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      // terkategorija: 'M',
      virtelclass: "terkk$panel$panel_novo_rucica_m",
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = 'B080010000000006';
    const H24 = x.calculated_ident;
    x.naziv = 'RUČICA ROLER PVC KLIMAFLEX 2 2651-305125-0062 INDUSTRILAS';
    // x.kolicina = XIF(H24 === "", "", XIF(tippanela === "vrata", XIF(visina > 1300, 4, XIF(visina > 800, 3, XIF(visina > 500, 2, "1")))));
    x.kolicina = _ukupna_kolicina_rucica_sa_i_bez_kljuca;
    x = {
      ...x,
      ..._getParamsFromLib("terkk$panel$panel_novo_rucica_m")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // stavka 14 M-Materijal ŠARKA PVC KLIMAFLEX 325070 INDUSTRILAS
    // derivat 6, u excelu 11
    // derivat local 14
    _derivat_key = 'derivat_m_sarka';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = 'B080010000000007';
    const H25 = x.calculated_ident;
    x.naziv = 'ŠARKA PVC KLIMAFLEX 325070 INDUSTRILAS';
    // x.kolicina = XIF(H25 === "", "", XIF(tippanela === "vrata", XIF(visina > 1300, 4, XIF(visina > 800, 3, XIF(visina > 500, 2, "1")))));
    x.kolicina = _ukupna_kolicina_rucica_sa_i_bez_kljuca;
    if (x.kolicina < 2) { // korekcija u slucaju da je izracunato manej od minimuma
      x.kolicina = 2; // minimalno dve sarke moraju da budu
    };
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // stavka 15 M-Materijal OSTALO SIGURNOSNA BRAVA T=50 mm
    // Ova stavka se pojavljuje samo u slucaju kada je odabrano SIGURNOSNA BRAVA: DA.
    if (v_input.sigurnosnabrava === "DA") {
      // derivat 7, u excelu 12 Ovo radimo samo ako je brava DA
      // derivat local 15
      _derivat_key = 'derivat_m_brava';
      x = {
        _derivat_key,
        virtelschemakey: 'terkk$panel$materijal2',
        virtelclass: "terkk$panel$sigurnosnabrava",
        jm: tclocal.JM_KOM
      };
      x.calculated_ident = 'B100000000000028';
      x.naziv = 'OSTALO SIGURNOSNA BRAVA T=50 mm';
      x.kolicina = SINGLE_PIECE; // DL 2023-09-01: ako ima sigurnosnabrava onda je kolicina samo JEDNA sigurnosnabrava. Nikada ne može da bude više od jedne sigurnosnabrava. Može samo da bude jedna ili da je nema uopšte.
      x = {
        ...x,
        ..._getParamsFromLib("terkk$panel$sigurnosnabrava")
      }; // parametri na kraju imaju prioritet
      z[_derivat_key] = x;
      _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    }

  }; // ZAVRSENE STAVKE ZA VRATA


  if (v_input.tippanela === 'opsluzioni' && v_input._KOMPLETAN_panel.panel_rucicarukohvat === "DA" && v_input._KOMPLETAN_panel.panel_rucicarukohvat_kolicina > 0) {
    // derivat local 11
    _derivat_key = 'derivat_m_rucicatukohvat';
    x = {
      _derivat_key,
      virtelschemakey: 'terkk$panel$materijal2',
      terkategorija: 'M',
      jm: tclocal.JM_KOM
    };
    x.calculated_ident = 'B080000000000011';
    x.naziv = 'RUCICA PVC UNIVERZALNA ALDON';
    x.kolicina = v_input._KOMPLETAN_panel.panel_rucicarukohvat_kolicina;
    z[_derivat_key] = x;
    // _virbom_manipulator.add_on_graphlevel(virbom_ref, x, _panel_not_vrata_graphlevel);
    _virbom_manipulator.add_on_graphlevel(virbom_ref, x, 1); //
  }

  /*
    virtelschemakey: 'terkk$panel$materijal2', // dodajemo semu na materijal 5
    graphpath: '/terkk$klimakomora/terkk$modul/terkk$panel$materijal2',
  */


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


const _derivat_panel_materijal1_by_pp = (p, key, tippanela) => {
  console.log('_derivat_panel_materijal1_by_pp(p, key) ', p, key);
  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  // v_input
  const _materijal_naziv = p._materijal_naziv;
  const tip = p.tip;
  const duzina = p.duzina;
  const sirinarazvijena = p.sirinarazvijena;
  const sirina = p.sirina;
  const visina = p.visina;
  const v_input = {
    tip,
    duzina,
    sirinarazvijena,
    _materijal_naziv,
    sirina,
    visina
  };

  let x = {
    naziv: v_input._materijal_naziv
  };
  x.calculated_ident = v_input.tip;
  x.terkategorija = 'M';

  // Ako je ojacanje odnosto derivat_pp_ojacanje drugacije se racuna kolicina
  if (key === 'derivat_pp_ojacanje') {
    let _kolicina = v_input.duzina * v_input.sirinarazvijena * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriKvadratniToMetriKvadratni(_kolicina, 2); // KONVERTUJEMO U M2
    x.jm = tclocal.JM_M2;
  } else if (key === 'derivat_pp_lim_spolj') {
    // DL 2021-10-21 Svi tipovi sem vrata - Sirina panela -7 mm * Visina panela - 7 mm - Konvertovati u m2
    let _kolicina = (v_input.sirina - 7) * (v_input.visina - 7) * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    if (tippanela === 'vrata') {
      // DL 2021-10-21 Tip Vrata - Sirina panela + 41 mm * Visina panela + 41 mm - Konvertovati u m2
      _kolicina = (v_input.sirina + 41) * (v_input.visina + 41) * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    }
    if (tippanela === 'panelbezprofila') {
      /*
      Razvijene mere:
      Spoljašnji lim
      Visina: Visina gotovog panela +36,8
      Širina: Širina gotovog panela + 36,8
      */
      const razvijenamera_lim_spolj_visina = (v_input.visina + 36.8);
      const razvijenamera_lim_spolj_sirina = (v_input.sirina + 36.8);
      _kolicina = razvijenamera_lim_spolj_sirina * razvijenamera_lim_spolj_visina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT;
    }
    x.kolicina = terUtilsUnitsMilimetriKvadratniToMetriKvadratni(_kolicina, 2); // KONVERTUJEMO U M2
    x.jm = tclocal.JM_M2;
  } else if (key === 'derivat_pp_lim_unutr') {
    // DL 2021-10-21 Sirina panela + 12 + 9.3 * Visina panela + 12 + 9.3
    let _kolicina = (v_input.sirina + 12 + 9.3) * (v_input.visina + 12 + 9.3) * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    if (tippanela === 'panelbezprofila') {
      /*
      Razvijene mere:
      Unutrašnji lim:
      Visina: Visina gotovog panela +81,4
      Širina: Širina gotovog panela + 81,4
      */
      const razvijenamera_lim_unutr_visina = (v_input.visina + 81.4);
      const razvijenamera_lim_unutr_sirina = (v_input.sirina + 81.4);
      _kolicina = razvijenamera_lim_unutr_sirina * razvijenamera_lim_unutr_visina;
    }
    x.kolicina = terUtilsUnitsMilimetriKvadratniToMetriKvadratni(_kolicina, 2); // KONVERTUJEMO U M2
    x.jm = tclocal.JM_M2;
  } else if (key === 'kamenavuna1' || key === 'kamenavuna2') {
    // console.log('**** TEST');
    // console.log(v_input);
    let _kolicina = v_input.sirina * v_input.visina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriKvadratniToMetriKvadratni(_kolicina, 2); // izuzetak ipak dve decimale za kamenu vunu jer je jedna sucise neprecizno
    x.jm = tclocal.JM_M2;
  } else {
    let _kolicina = v_input.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
    x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
    x.jm = tclocal.JM_M;
  };
  // TODO: ovde imamo dva puta polje kolicina

  // posto materijal nece na backendu da se cuva odmah ovde delimicno kompletiramo virtel plitki
  const virtel_plitki_materijal = {
    // ...v_input,
    ...x
  };
  return virtel_plitki_materijal;
};


export const _derivat_panel_lim_cncprogram = (_is_lim_spolj, tippanela) => {
  /*
  "name": "tippanela",
  "options": [
    { "title": "STANDARDNI", "value": "standardni" },
    { "title": "OPSLUZIONI", "value": "opsluzioni" },
    { "title": "PODNI", "value": "podni" },
    { "title": "OKRUGLI OTVOR x 1", "value": "okrugliotvor1" },
    { "title": "OKRUGLI OTVOR x 2", "value": "okrugliotvor2" },
    { "title": "PANEL IZMENJIVACA", "value": "panelizmenjivaca" },
    { "title": "KVADRATNI OTVOR", "value": "kvadratniotvor" },
    { "title": "KVADRATNI OTVOR x 2", "value": "kvadratniotvor2" },
    { "title": "VRATA", "value": "vrata" }
  ]
  */
  let cnc_program = null;
  if (_is_lim_spolj === true) { // SPOLJASNJI LIM CNC
    // Kod cnc programa za spoljaasnji lim se koristi naziv "Front" (kao kod kuhinjskih elemenata gde su frontovi spolja).
    if (tippanela === 'standardni') {
      cnc_program = 'Lim AHU Panel Front.S4';
    }
    if (tippanela === 'opsluzioni') {
      cnc_program = 'Lim AHU Panel Opsluzioni Front.S4';
    }
    if (tippanela === 'podni') {
      // usto kao za standardni
      cnc_program = 'Lim AHU Panel Front.S4';
    }
    if (tippanela === 'okrugliotvor1') {
      cnc_program = 'Lim AHU Panel A Front.S4';
    }
    if (tippanela === 'okrugliotvor2') {
      cnc_program = 'Lim AHU Panel B Front.S4';
    }
    if (tippanela === 'panelizmenjivaca') {
      // isti kao za okrugli otvor x 2
      cnc_program = 'Lim AHU Panel B Front.S4';
    }
    if (tippanela === 'kvadratniotvor') {
      cnc_program = 'Lim AHU Panel K Front.S4';
    }
    if (tippanela === 'kvadratniotvor2') {
      cnc_program = 'Lim AHU Panel K2 Front.S4';
    }
    if (tippanela === 'vrata') {
      cnc_program = 'Lim AHU Vrata Front.S4';
    }
    if (tippanela === 'panelbezprofila') {
      cnc_program = 'Lim AHU Panel Bez Profila Front.S4';
    }
  } else { // UNUTRASNJI LIM CNC
    // Kod cnc programa za spoljaasnji lim se koristi naziv "Back" (suprotno od Front koji je spolja spolja).
    if (tippanela === 'standardni') {
      cnc_program = 'Lim AHU Panel Back.S4';
    }
    if (tippanela === 'opsluzioni') {
      cnc_program = 'Lim AHU Panel Opsluzioni Back.S4';
    }
    if (tippanela === 'podni') {
      // usto kao za standardni
      cnc_program = 'Lim AHU Panel Back.S4';
    }
    if (tippanela === 'okrugliotvor1') {
      cnc_program = 'Lim AHU Panel A Back.S4';
    }
    if (tippanela === 'okrugliotvor2') {
      cnc_program = 'Lim AHU Panel B Back.S4';
    }
    if (tippanela === 'panelizmenjivaca') {
      // isti kao za okrugli otvor x 2
      cnc_program = 'Lim AHU Panel B Back.S4';
    }
    if (tippanela === 'kvadratniotvor') {
      cnc_program = 'Lim AHU Panel K Back.S4';
    }
    if (tippanela === 'kvadratniotvor2') {
      cnc_program = 'Lim AHU Panel K2 Back.S4';
    }
    if (tippanela === 'vrata') {
      cnc_program = 'Lim AHU Vrata Back.S4';
    }
    if (tippanela === 'panelbezprofila') {
      cnc_program = 'Lim AHU Panel Bez Profila Back.S4';
    }
  }
  return cnc_program;
};


//
export const _derivat_panel_lim_spoljasnji = (panel) => {
  // uvek je 0.5 spoljnji lim i on je uvek plastificiran
  // x.tip = 'LBJAR00A'; // spoljasni lim uvek isti tip
  // DL 2022-09-13: SPOLJASNJI LIM PANELA JE ZA SADA UVEK LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
  // const _lim_spoljasnji_naziv = 'LIM GS S280GD, gloss 50% RAL 9010, 0.50x1220x3000mm';
  // const panel_lim_spoljasnji_tip = "LBMAU00A"; // spoljasni lim uvek isti tip
  //
  // NOVO 2024-12-12
  //
  const {
    panel_materijal_lim_spoljasnji,
    tippanela,
    panel_materijal_lim_spoljasnji_panelbezprofila,
  } = panel;
  //
  // let _lim_spoljasnji_naziv = 'LIM GS S280GD, gloss 50% RAL 9010, 0.50x1220x3000mm';
  // let panel_lim_spoljasnji_tip = "LBMAU00A"; // spoljasni lim uvek isti tip
  let _lim_spoljasnji_naziv = '?';
  let panel_lim_spoljasnji_tip = null; // spoljasni lim uvek isti tip
  // korišćenje izabranih materijala iz forme
  if (tippanela === 'panelbezprofila') {
    if (typeof panel_materijal_lim_spoljasnji_panelbezprofila === 'string') {
      panel_lim_spoljasnji_tip = panel_materijal_lim_spoljasnji_panelbezprofila;
      const _mat_params = _getParamsFromLibMaterijalLimParams(panel_lim_spoljasnji_tip); // primer LBJAR00A ili LBJAR00D
      if (typeof _mat_params.naziv === 'string') {
        _lim_spoljasnji_naziv = _mat_params.naziv;
      }
    }
  } else {
    if (typeof panel_materijal_lim_spoljasnji === 'string') {
      panel_lim_spoljasnji_tip = panel_materijal_lim_spoljasnji;
      const _mat_params = _getParamsFromLibMaterijalLimParams(panel_lim_spoljasnji_tip); // primer LBJAR00A ili LBJAR00D
      if (typeof _mat_params.naziv === 'string') {
        _lim_spoljasnji_naziv = _mat_params.naziv;
      }
    }
  }
  //
  const x = {
    _materijal_naziv: _lim_spoljasnji_naziv,
    tip: panel_lim_spoljasnji_tip
  };
  return x;
};


//
export const _derivat_panel_lim_unutrasnji = (panel) => {
  // NOVO 2024-01-22
  //
  console.log('_derivat_panel_lim_unutrasnji(panel)', panel);
  const {
    tippanela,
    tipkomore,
    unutrasnjaoplata,

    panel_materijal_lim_unutrasnji_redovni,
    panel_materijal_lim_unutrasnji_redovni_podni,
    panel_materijal_lim_unutrasnji_hygiene_prohrom,
    panel_materijal_lim_unutrasnji_hygiene_plastificirani,
    panel_materijal_lim_unutrasnji_hygiene_podni,
    panel_materijal_lim_unutrasnji_panelbezprofila,
  } = panel;
  console.log('++++ TEST 1', tippanela, tipkomore, unutrasnjaoplata);
  console.log('++++ TEST 2 panel_materijal_lim_unutrasnji_redovni', panel_materijal_lim_unutrasnji_redovni);
  //
  // unutrasnji lim panela je uvek 0.5 izuzev kad je podni onda je 0.8
  // DL 2022-09-07: tip lima za debljinu lima 0.5 je LBJAR00A a za 0.8 je LBJAR00D.
  let x = {};
  const _default = {};
  _default._materijal_naziv = 'LIM GS S280GD, gloss 50% RAL 9010, 0.50x1220x3000mm'; // dwfault
  _default.tip = "LBMAU00A"; // default
  if (tipkomore === 'STD:pro' || tipkomore === 'HYDRA:pro' || tipkomore === 'ENERGY:pro') {
    // DL 2022-09-13:
    /*
    Tip: STD:pro, HYDRA:pro, ENERGY:pro
    Svi sem podnog
    LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
    Podni
    LBJAR00D - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80
    */
    if (tippanela === 'podni') {
      // Podni LBJAR00D - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80
      // x._materijal_naziv = 'LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80';
      // x.tip = 'LBJAR00D';
      x.tip = panel_materijal_lim_unutrasnji_redovni_podni;
    } else {
      // Svi sem podnog LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
      // isti kao default
      // x._materijal_naziv = _default._materijal_naziv;
      // x.tip = _default.tip;
      x.tip = panel_materijal_lim_unutrasnji_redovni;
    }
  } else if (tipkomore === 'HYGIENE:pro') {
    /*
    Tip: HYGIENE:pro - Plastificirano
    Svi sem podnog
    LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
    Podni
    LC00000D - LIM SS 0.80

    Tip: HYGIENE:pro - Prohrom
    Svi sem podnog
    LC00000A - LIM SS 0.50
    Podni
    LC00000D - LIM SS 0.80
    */
    if (tippanela === 'podni') {
      // samo za podni
      // Podni LC00000D - LIM SS 0.80
      console.log('TEST 2 podni');
      // x._materijal_naziv = 'LIM SS 0.80';
      // x.tip = 'LC00000D';
      x.tip = panel_materijal_lim_unutrasnji_hygiene_podni;
    } else {
      // svi osim podnog
      if (unutrasnjaoplata === 'plastificirano') {
        // isto kao default
        // x._materijal_naziv = _default._materijal_naziv;
        // x.tip = _default.tip;
        x.tip = panel_materijal_lim_unutrasnji_hygiene_plastificirani;
      }
      if (unutrasnjaoplata === 'prohrom') {
        console.log('TEST 2 svi sem podnog + prohrom');
        // x._materijal_naziv = 'LIM SS 0.50';
        // x.tip = 'LC00000A';
        x.tip = panel_materijal_lim_unutrasnji_hygiene_prohrom;
      }
    }
  }
  //
  if (tippanela === 'panelbezprofila') {
    x.tip = panel_materijal_lim_unutrasnji_panelbezprofila;
  }
  //
  x._materijal_naziv = '?';
  if (typeof x.tip === 'string') {
    const _mat_params = _getParamsFromLibMaterijalLimParams(x.tip); // primer LBJAR00A ili LBJAR00D
    x._materijal_naziv = '?';
    if (typeof _mat_params.naziv === 'string') {
      x._materijal_naziv = _mat_params.naziv;
    }
  }
  //
  return x;
};

// korišćen pre 2024-01-52
const OLD_derivat_panel_lim_unutrasnji = (tippanela, tipkomore, unutrasnjaoplata) => {
  console.log('++++ TEST 1', tippanela, tipkomore, unutrasnjaoplata);
  // unutrasnji lim panela je uvek 0.5 izuzev kad je podni onda je 0.8
  // DL 2022-09-07: tip lima za debljinu lima 0.5 je LBJAR00A a za 0.8 je LBJAR00D.
  let x = {};
  const _default = {};
  _default._materijal_naziv = 'LIM GS S280GD, gloss 50% RAL 9010, 0.50x1220x3000mm'; // dwfault
  _default.tip = "LBMAU00A"; // default
  if (tipkomore === 'STD:pro' || tipkomore === 'HYDRA:pro' || tipkomore === 'ENERGY:pro') {
    // DL 2022-09-13:
    /*
    Tip: STD:pro, HYDRA:pro, ENERGY:pro
    Svi sem podnog
    LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
    Podni
    LBJAR00D - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80
    */
    if (tippanela === 'podni') {
      // Podni LBJAR00D - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80
      x._materijal_naziv = 'LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.80';
      x.tip = 'LBJAR00D';
    } else {
      // Svi sem podnog LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
      // isti kao default
      x._materijal_naziv = _default._materijal_naziv;
      x.tip = _default.tip;
    }
  } else if (tipkomore === 'HYGIENE:pro') {
    /*
    Tip: HYGIENE:pro - Plastificirano
    Svi sem podnog
    LBJAR00A - LIM GS DX51D+Z100MC SKZ 291099 / 100001 0.50
    Podni
    LC00000D - LIM SS 0.80

    Tip: HYGIENE:pro - Prohrom
    Svi sem podnog
    LC00000A - LIM SS 0.50
    Podni
    LC00000D - LIM SS 0.80
    */
    if (tippanela === 'podni') {
      // samo za podni
      // Podni LC00000D - LIM SS 0.80
      console.log('TEST 2 podni');
      x._materijal_naziv = 'LIM SS 0.80';
      x.tip = 'LC00000D';
    } else {
      // svi osim podnog
      if (unutrasnjaoplata === 'plastificirano') {
        // isto kao default
        x._materijal_naziv = _default._materijal_naziv;
        x.tip = _default.tip;
      }
      if (unutrasnjaoplata === 'prohrom') {
        console.log('TEST 2 svi sem podnog + prohrom');
        x._materijal_naziv = 'LIM SS 0.50';
        x.tip = 'LC00000A';
      }
    }
  }
  return x;
};


export const derivatPoluproizvod_panel_korigovane_dimenzije_nakon_unosa = (_sirina, _visina, tipunosapanela, tippanela) => {
  /*
  Kad je GOTOV PANEL znaci da su visina i širina panela unešene u formu su prave dimenzije panela. 
  A kada je tip unosa SVETLI OTVOR to značu da su u polja širina i visina u formi zapravo unešene dimenzija prostora unutar kojeg će panel da bude smešten i taj prostor je nekoliko milimetara većih dimenzija od samog panela.
  Odmah nakon unosa u formu od tih privremenih dimenzija treba dobiti prave dimenzije panela i dalje su nam potrebne samo prave dimenzije panela.
  TODO: Pošto se u bavzi čuvaju samo prave dimenzije panela, treba voditi računa da se pri konverziji u draftele za te prave uvek podesi tip unosa GOTOV PANEL.
  */
  let sirinaUpdated = _sirina;
  let visinaUpdated = _visina;
  if (tipunosapanela === "SVETLI_OTVOR") {
    if (tippanela === "vrata") {
      // ako je tippanela vrata, umanjujejmo za 6mm. Potpuno ignorišemo da li vrata imaju reviziju ili ne.
      const KOREKCIJA_ZA_TIP_VRATA = 6;
      sirinaUpdated = _sirina - KOREKCIJA_ZA_TIP_VRATA;
      visinaUpdated = _visina - KOREKCIJA_ZA_TIP_VRATA;
    } else if (tippanela === "panelbezprofila") {
      // ako je tippanela panelbezprofila,
      // NJ 2024-12-17: Zazor panela u odnosu na svetli otvor je 2mm u visini i širini.
      const KOREKCIJA_ZA_TIP_PANELBEZPROFILA = 2;
      sirinaUpdated = _sirina - KOREKCIJA_ZA_TIP_PANELBEZPROFILA;
      visinaUpdated = _visina - KOREKCIJA_ZA_TIP_PANELBEZPROFILA;
    } else {
      // sve ostale umanjujemo za 2mm.
      const KOREKCIJA = 2;
      sirinaUpdated = _sirina - KOREKCIJA;
      visinaUpdated = _visina - KOREKCIJA;
    }
  }
  return {
    sirina: sirinaUpdated,
    visina: visinaUpdated
  };
};


export const derivatPoluproizvod_panel_korigovane_dimenzije_iz_virtela_u_draftel = (sirina, visina, tipunosapanela, tippanela) => {
  /*
  funkcija kora radi suprotno od derivatPoluproizvod_panel_korigovane_dimenzije_nakon_unosa
  */
  let sirinaUpdated = sirina;
  let visinaUpdated = visina;
  if (tipunosapanela === "SVETLI_OTVOR") {
    if (tippanela === "vrata") {
      // ako je tippanela vrata, UVEĆAVAMO za 6mm. Potpuno ignorišemo da li vrata imaju reviziju ili ne.
      const KOREKCIJA_ZA_TIP_VRATA = 6;
      sirinaUpdated = sirina + KOREKCIJA_ZA_TIP_VRATA;
      visinaUpdated = visina + KOREKCIJA_ZA_TIP_VRATA;
    } else if (tippanela === "panelbezprofila") {
      // ako je tippanela panelbezprofila, UVEĆAVAMO za 3mm.
      const KOREKCIJA_ZA_TIP_PANELBEZPROFILA = 3;
      sirinaUpdated = sirina + KOREKCIJA_ZA_TIP_PANELBEZPROFILA;
      visinaUpdated = visina + KOREKCIJA_ZA_TIP_PANELBEZPROFILA;
    } else {
      // sve ostale UVEĆAVAMO za 2mm.
      const KOREKCIJA = 2;
      sirinaUpdated = sirina + KOREKCIJA;
      visinaUpdated = visina + KOREKCIJA;
    }
  }
  return {
    _sirina: sirinaUpdated,
    _visina: visinaUpdated
  };
};


export const derivatPoluproizvodPanelParametriZaS4 = (p) => {
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva

  // promenljive iz excela
  const visina = p.eliminatorkapi;
  const J10 = p.smervazduha;
  const K10 = p.a;
  const L10 = p.b;
  const M10 = p.c;
  const N10 = p.e;
  const O10 = p.f;

  // console.log(visina, J10, K10, L10, M10, N10, O10);

  const D8 = p.tipunosapanela;
  const D10 = p.sirina;
  const E10 = p.visina;
  const C10 = p.tippanela;

  const G10 = XIF(D8 === "IZABERI TIP UNOSA", "", XIF(D10 === "", "", XIF(AND(D8 === "SVETLI OTVOR", C10 === "vratasarevizijom"), D10 - 6, XIF(AND(D8 === "SVETLI OTVOR", C10 === "vrata"), D10 - 6, XIF(AND(D8 === "GOTOV PANEL"), D10, D10 - 2)))));
  const H10 = XIF(D8 === "IZABERI TIP UNOSA", "", XIF(D10 === "", "", XIF(AND(D8 === "SVETLI OTVOR", C10 === "vratasarevizijom"), E10 - 6, XIF(AND(D8 === "SVETLI OTVOR", C10 === "vrata"), E10 - 6, XIF(AND(D8 === "GOTOV PANEL"), E10, E10 - 2)))));


  x = {};
  x.x1 = XIF(OR(C10 === "okrugliotvor1", C10 === "kvadratniotvor"), "?", XIF(visina === "NE", G10 / 2 - L10 / 2, XIF(AND(visina === "DA", J10 === "V1"), (G10 / 2) - ((K10 + L10 + M10 + 40 + 140) / 2) + K10, XIF(AND(visina === "DA", J10 === "V2"), (G10 / 2) + (((K10 + L10 + M10 + 40 + 140) / 2) - L10 - M10), 0))));
  x.y1 = XIF(OR(C10 === "okrugliotvor1", C10 === "kvadratniotvor"), "?", XIF(J10 === "V1", 19 + O10 + N10, XIF(J10 === "V2", 19 + O10, 0)));
  x.x2 = XIF(visina === "NE", G10 / 2 + L10 / 2, XIF(AND(visina === "DA", J10 === "V1"), ((G10 / 2) - ((K10 + L10 + M10 + 40 + 140) / 2)) + K10 + L10, XIF(AND(visina === "DA", J10 === "V2"), (G10 / 2) + (((K10 + L10 + M10 + 40 + 140) / 2) - M10), 0)));
  x.y2 = XIF(J10 === "V1", 19 + O10, XIF(J10 === "V2", 19 + O10 + N10, 0));
  z["PARAMETRI"] = x;

  return z;
}


const _izracunaj_ojacanja_NoviSistem = (sirinaPanela, visinaPanela, tippanela, revizioniotvor) => {
  // _PRONADJIME
  let ojacanje = {
    brojKomadaOjacanja: 0,
    duzinaOjacanja: 0,
    sirinaOjacanja: 125, // DL 2022-04-25: 125 je sirina ojacanja i to je uvek 125 fiksno.
    sirinaProfilaPanela: 20 // debljinu profila oduzimamo od visine/sirine da bi dobili duzinu za ojacanje
  };
  if (tippanela === 'panelbezprofila') { // NJ 2024-12-04: Panel bez profila nikada nema ojačanja.
    ojacanje.brojKomadaOjacanja = 0;
    return ojacanje;
  }
  // 2023-11-24 DL: Poverio da kada je tippanela vrata da nema ojacanja. Dakle, kada su vrata,e po defaultu ostaje brojKomadaOjacanja: 0.
  if (sirinaPanela && visinaPanela && tippanela) {
    // Ojacanja uvek idu po kracoj kracoj strani. 
    if (tippanela === 'podni') {
      if (sirinaPanela > visinaPanela && visinaPanela > 300) {
        // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
        if (sirinaPanela > 500) {
          ojacanje.brojKomadaOjacanja = 1;
        }
        if (sirinaPanela > 999) {
          ojacanje.brojKomadaOjacanja = 2;
        }
        if (sirinaPanela > 1500) {
          ojacanje.brojKomadaOjacanja = 3;
        }
      }
      if (js_utils.is_number_less_than_or_equal_number2(sirinaPanela, visinaPanela) && sirinaPanela > 300) {
        // <=
        // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
        if (visinaPanela > 500) {
          ojacanje.brojKomadaOjacanja = 1;
        }
        if (visinaPanela > 999) {
          ojacanje.brojKomadaOjacanja = 2;
        }
        if (visinaPanela > 1500) {
          ojacanje.brojKomadaOjacanja = 3;
        }
      }
    } else if (tippanela === 'standardni' || tippanela === 'opsluzioni') {
      /*
      // DL 2023-04-28: Sada u ove dve formule nema razlika da li je sirina ili visina veca ali smo ih zadrzali ako nekada u buducnosti zatreba da ipak imamo posebno.
      if (sirinaPanela > visinaPanela && sirinaPanela > 800 && visinaPanela > 600) {
        // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
        ojacanje.brojKomadaOjacanja = 1;
      };
      if (sirinaPanela <= visinaPanela && visinaPanela > 800 && sirinaPanela > 600) {
        // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
        ojacanje.brojKomadaOjacanja = 1;
      };
      */
      // NOVO DL 2023-06-07
      if (sirinaPanela > visinaPanela && visinaPanela > 600) {
        // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
        if (sirinaPanela > 800) {
          ojacanje.brojKomadaOjacanja = 1;
        }
        if (sirinaPanela > 1500) {
          ojacanje.brojKomadaOjacanja = 2;
        }
        if (sirinaPanela > 2000) {
          ojacanje.brojKomadaOjacanja = 3;
        }
      }
      if (js_utils.is_number_less_than_or_equal_number2(sirinaPanela, visinaPanela) && sirinaPanela > 600) {
        // <=
        // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
        if (visinaPanela > 800) {
          ojacanje.brojKomadaOjacanja = 1;
        }
        if (visinaPanela > 1500) {
          ojacanje.brojKomadaOjacanja = 2;
        }
        if (visinaPanela > 2000) {
          ojacanje.brojKomadaOjacanja = 3;
        }
      }
    }
    if (revizioniotvor === "DA") {
      // DL 2023-06-07: Ako ima revizioni otvor ne moze da ima ojacanje u sredini. ne moze da bude ni 1 ni 3 ojacanja. Samo može da bude 0 ili 2.
      if (ojacanje.brojKomadaOjacanja === 3) {
        ojacanje.brojKomadaOjacanja = 2;
      }
      if (ojacanje.brojKomadaOjacanja === 1) {
        ojacanje.brojKomadaOjacanja = 0;
      }
    }
    // sad racunamo duzinu ojacanja koja ovisi o dimenziji krace strane panela
    if (sirinaPanela > visinaPanela) {
      // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
      ojacanje.duzinaOjacanja = visinaPanela - (ojacanje.sirinaProfilaPanela * 2) + 32; // 32 dodajemo zbog 16mm zgloba sa obe strane
    } else {
      // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
      ojacanje.duzinaOjacanja = sirinaPanela - (ojacanje.sirinaProfilaPanela * 2) + 32; // 32 dodajemo zbog 16mm zgloba sa obe strane
    }
  }
  return ojacanje;
};


const derivatPoluproizvodPanel_KamenaVunaNoviSistem_virtel = (sirinaPanela, visinaPanela, ojacanje, sistempanela, tipispuneklimakomore, tippanela) => {
  console.log('derivatPoluproizvodPanel_KamenaVunaNoviSistem_virtel() ');
  console.log(sirinaPanela, visinaPanela, ojacanje, sistempanela, tipispuneklimakomore);
  // _PRONADJIME

  const ZAZOR = 0; // DL 2022-04-25: za sada neka zazor bude 0
  const ZAZOR_SLUCAJ_VRATA = 1; // DL 2022-04-25: za sada neka zazor bude 1mm sa svake strane
  const ZAZOR_SLUCAJ_PANELBEZPROFILA = 1.5; // NJ 2024-12-17: Zazor kamene je 3mm u visini i širini u odnosu na gotov panel.
  const MAKSIMALNA_SIRINA_TABLE_VUNE = 1200;
  const MAKSIMALNA_VISINA_TABLE_VUNE = 2000;

  let kamenaVuna = {
    brojKomada: 0,
    sirina: 0, // Ovo se racuna
    visina: 0, // Ovo se racuna
    tip: 'sifra kamene vune'
  };

  // ojacanje je komad lima u kojem je smestena kamena vuna. ukupna sirina ojacanja je 125 uvek fiksno.
  let kamenaVunaUOjacanju = {
    brojKomada: 0,
    sirina: 122, // DL 2022-04-25: To je sirina kamene vune u ojacanju i ona je fiksno 122 i od toga se ne oduzima zazor.
    visina: 0, // Ovo se racuna
    tip: 'sifra kamene vune'
  };

  if (ojacanje.brojKomadaOjacanja === 0) { // ukoliko nema ojacanja u panelu
    // sva kamena vuna je izvan ojacanja u jednom delu
    // U ovom slucaju broj komada u ojacanju ostaje 0.
    kamenaVuna.brojKomada = 1; // kamena vuna je iz jednog dela
    //
    // u slucaju kada nema ojacanja može da bude da su u pitanju vrata jer panel vrata nikada nema ojacanja.
    if (tippanela === "vrata") {
      // DL 2023-11-24: Korekcija u slucaju da je tippanela vrata
      // podarzumevamo vec da nema ojacanja
      // kamenaVuna.sirina = kamenaVuna.sirina - (2 * ZAZOR_SLUCAJ_VRATA);
      // kamenaVuna.visina = kamenaVuna.visina - (2 * ZAZOR_SLUCAJ_VRATA);
      // kamenaVuna.sirina = sirinaPanela - (2 * ZAZOR_SLUCAJ_VRATA);
      // kamenaVuna.visina = visinaPanela - (2 * ZAZOR_SLUCAJ_VRATA);
      kamenaVuna.sirina = (sirinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR_SLUCAJ_VRATA);
      kamenaVuna.visina = (visinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR_SLUCAJ_VRATA);
    } else if (tippanela === "panelbezprofila") {
      // DL 2024-12-04: Korekcija u slucaju da je tippanela panelbezprofila
      // podarzumevamo vec da nema ojacanja
      kamenaVuna.sirina = sirinaPanela - (2 * ZAZOR_SLUCAJ_PANELBEZPROFILA);
      kamenaVuna.visina = visinaPanela - (2 * ZAZOR_SLUCAJ_PANELBEZPROFILA);
    } else {
      kamenaVuna.sirina = (sirinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
      kamenaVuna.visina = (visinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
    }
    console.log(kamenaVuna);
    //
  } else { // ukoliko ima ojacanja u panelu
    // kamena vuna izvan ojacanja
    kamenaVuna.brojKomada = ojacanje.brojKomadaOjacanja + 1;
    if (sirinaPanela > visinaPanela) {
      // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
      kamenaVuna.sirina = ((sirinaPanela - (ojacanje.sirinaProfilaPanela * 2) - (ojacanje.brojKomadaOjacanja * ojacanje.sirinaOjacanja)) / kamenaVuna.brojKomada) - (2 * ZAZOR);
      kamenaVuna.visina = (visinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
    } else {
      // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
      kamenaVuna.sirina = ((visinaPanela - (ojacanje.sirinaProfilaPanela * 2) - (ojacanje.brojKomadaOjacanja * ojacanje.sirinaOjacanja)) / kamenaVuna.brojKomada) - (2 * ZAZOR);
      kamenaVuna.visina = (sirinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
    }
    // kamena vuna u ojacanju
    kamenaVunaUOjacanju.brojKomada = ojacanje.brojKomadaOjacanja;
    if (sirinaPanela > visinaPanela) {
      // Ako je visina kraca od sirine onda ojacanja idu po visini tj. vertikalno.
      kamenaVunaUOjacanju.visina = (visinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
    } else {
      // ovo pokriva slucaj sirinaPanela < visinaPanela i kada su jednake
      kamenaVunaUOjacanju.visina = (sirinaPanela - (ojacanje.sirinaProfilaPanela * 2)) - (2 * ZAZOR);
    }
  }

  // 2023-06-28 korekcija u slucaju da su dimenzije vune vece od dimenzije table vune
  if (kamenaVuna.sirina > MAKSIMALNA_SIRINA_TABLE_VUNE && kamenaVuna.visina > MAKSIMALNA_VISINA_TABLE_VUNE) {
    // delimo na 4
    kamenaVuna.sirina = kamenaVuna.sirina / 2;
    kamenaVuna.visina = kamenaVuna.visina / 2;
    kamenaVuna.brojKomada = kamenaVuna.brojKomada * 4;
  } else {
    if (kamenaVuna.visina > MAKSIMALNA_VISINA_TABLE_VUNE) {
      // delimo na dve po visini
      kamenaVuna.visina = kamenaVuna.visina / 2;
      kamenaVuna.brojKomada = kamenaVuna.brojKomada * 2;
    } else {
      // if (kamenaVuna.sirina > MAKSIMALNA_SIRINA_TABLE_VUNE) {
      if (kamenaVuna.sirina > MAKSIMALNA_VISINA_TABLE_VUNE) {
        // uzeli smo u obzir opet visinu table vune da ne dolazi do deljenje nepotrebnog ukoliko je sirina izmenju masimalne sirina i visine table vune.
        // delimo na dve po sirini
        kamenaVuna.sirina = kamenaVuna.sirina / 2;
        kamenaVuna.brojKomada = kamenaVuna.brojKomada * 2;
      }
    }
  }
  //
  if (kamenaVunaUOjacanju.visina > MAKSIMALNA_VISINA_TABLE_VUNE) {
    // delimo na dve po visini
    kamenaVunaUOjacanju.visina = kamenaVunaUOjacanju.visina / 2;
    kamenaVunaUOjacanju.brojKomada = kamenaVunaUOjacanju.brojKomada * 2;
  } else {
    // sirina kamene vune u ojacanju je uvek 122 tako da nikada ne prelazi maksimalne dimenzije table vune po sirini.
  }
  //
  //
  const brojDelovaKameneVune = kamenaVuna.brojKomada + kamenaVunaUOjacanju.brojKomada; // ukupan broj komada kamene vune i u ojacanju i van ojacanja

  // ZAOKRUZIVANJE NAKON STO JE SVE IZRACUNATO PRECIZNO
  // DL 2023-11-02: Kamena vuna sirina i visina da se zaokruziuju normalno preko 0.5 ili manje od 0.5 na nula decimala.
  kamenaVuna.sirina = terUtilsNumberRoundClassic(kamenaVuna.sirina, 0);
  kamenaVuna.visina = terUtilsNumberRoundClassic(kamenaVuna.visina, 0);
  kamenaVunaUOjacanju.sirina = terUtilsNumberRoundClassic(kamenaVunaUOjacanju.sirina, 0);
  kamenaVunaUOjacanju.visina = terUtilsNumberRoundClassic(kamenaVunaUOjacanju.visina, 0);

  //
  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva

  // Derivat kamena vuna velika
  x = {
    virtelclass: "terkk$panel$ispuna",
    duzina: '',
    sirinarazvijena: '',
  };
  x.calculated_ident = 'PRW000001'; // Treba da se generise
  // x.calculated_ident = XIF(AND(I2 === "starisistem", I5 === "kamenavuna"), "A02BB04511803180", XIF(AND(I2 === "starisistem", I5 === "poliuretan"), "A02AA04512503020", XIF(AND(I2 === "novisistem", I5 === "kamenavuna"), "IAGIA45", XIF(AND(I2 === "novisistem", I5 === "poliuretan"), "IFF0030A0045", "?"))));
  x.naziv = 'KAMENA VUNA ' + kamenaVuna.sirina + 'x' + kamenaVuna.visina + 'mm - ' + brojDelovaKameneVune + 'D'; // DL 2023-11-02: U nazivu zaokruzii na nula decimala // Vec je zaokruzeno iznad
  // x.naziv = XIF(H17 === "A02BB04511803180", "PANEL KAMENA VUNA 41420453 POC-POC 0.50/0.50 MV 45X1180X3180mm", XIF(H17 === "A02AA04512503020", "PANEL POLIURETAN 16BB45 POC-POC 0.5/0.5 45X1250X3020mm", XIF(H17 === "IAGIA45", "ISPUNA KAMENA VUNA CORE BP 30 PLUS 130 kg/m3  45x1000x2400mm", XIF(H17 === "IFF0030A0045", "ISPUNA POLISTIRENE XPS 30 kg/m3 45mm", "?"))));
  x.kolicina = kamenaVuna.brojKomada; // Treba da se racuna automatski u odnosu na broj ojacanja!
  x.tip = XIF(AND(sistempanela === "starisistem", tipispuneklimakomore === "kamenavuna"), "A02BB04511803180", XIF(AND(sistempanela === "starisistem", tipispuneklimakomore === "poliuretan"), "A02AA04512503020", XIF(AND(sistempanela === "novisistem", tipispuneklimakomore === "kamenavuna"), "IAGIA45", XIF(AND(sistempanela === "novisistem", tipispuneklimakomore === "poliuretan"), "IFF0030A0045", "?"))));
  const H17 = x.tip;
  x._materijal_naziv = XIF(H17 === "A02BB04511803180", "PANEL KAMENA VUNA 41420453 POC-POC 0.50/0.50 MV 45X1180X3180mm", XIF(H17 === "A02AA04512503020", "PANEL POLIURETAN 16BB45 POC-POC 0.5/0.5 45X1250X3020mm", XIF(H17 === "IAGIA45", "ISPUNA KAMENA VUNA CORE BP 30 PLUS 130 kg/m3  45x1000x2400mm", XIF(H17 === "IFF0030A0045", "ISPUNA POLISTIRENE XPS 30 kg/m3 45mm", "?"))));
  // x.sirina = XIF(I2 === "starisistem", (sirina - 4), "?");
  // x.visina = XIF(I2 === "starisistem", (visina - 4), "?");
  x.sirina = kamenaVuna.sirina;
  x.visina = kamenaVuna.visina;
  // ovo ce biti uklopljeno u local virbom u glavnoj AutoCreate funkciji
  z['kamenavuna1'] = x;

  if (kamenaVunaUOjacanju.brojKomada > 0) {
    // Derivat kamena vuna u ojacanju
    x = {
      virtelclass: "terkk$panel$ispuna",
      duzina: '',
      sirinarazvijena: '',
    };
    x.calculated_ident = 'PRW000001'; // Treba da se generise
    // x.calculated_ident = XIF(AND(I2 === "starisistem", I5 === "kamenavuna"), "A02BB04511803180", XIF(AND(I2 === "starisistem", I5 === "poliuretan"), "A02AA04512503020", XIF(AND(I2 === "novisistem", I5 === "kamenavuna"), "IAGIA45", XIF(AND(I2 === "novisistem", I5 === "poliuretan"), "IFF0030A0045", "?"))));
    x.naziv = 'KAMENA VUNA ' + terUtilsNumberRoundUp(kamenaVunaUOjacanju.sirina, 1) + 'x' + terUtilsNumberRoundUp(kamenaVunaUOjacanju.visina, 1) + 'mm - ' + brojDelovaKameneVune + 'D';
    // x.naziv = XIF(H17 === "A02BB04511803180", "PANEL KAMENA VUNA 41420453 POC-POC 0.50/0.50 MV 45X1180X3180mm", XIF(H17 === "A02AA04512503020", "PANEL POLIURETAN 16BB45 POC-POC 0.5/0.5 45X1250X3020mm", XIF(H17 === "IAGIA45", "ISPUNA KAMENA VUNA CORE BP 30 PLUS 130 kg/m3  45x1000x2400mm", XIF(H17 === "IFF0030A0045", "ISPUNA POLISTIRENE XPS 30 kg/m3 45mm", "?"))));
    x.kolicina = kamenaVunaUOjacanju.brojKomada; // Treba da se racuna automatski u odnosu na broj ojacanja!
    // x.sirina = XIF(I2 === "starisistem", (sirina - 4), "?");
    // x.visina = XIF(I2 === "starisistem", (visina - 4), "?");
    x.sirina = kamenaVunaUOjacanju.sirina;
    x.visina = kamenaVunaUOjacanju.visina;
    x.tip = XIF(AND(sistempanela === "starisistem", tipispuneklimakomore === "kamenavuna"), "A02BB04511803180", XIF(AND(sistempanela === "starisistem", tipispuneklimakomore === "poliuretan"), "A02AA04512503020", XIF(AND(sistempanela === "novisistem", tipispuneklimakomore === "kamenavuna"), "IAGIA45", XIF(AND(sistempanela === "novisistem", tipispuneklimakomore === "poliuretan"), "IFF0030A0045", "?"))));
    const H17 = x.tip;
    x._materijal_naziv = XIF(H17 === "A02BB04511803180", "PANEL KAMENA VUNA 41420453 POC-POC 0.50/0.50 MV 45X1180X3180mm", XIF(H17 === "A02AA04512503020", "PANEL POLIURETAN 16BB45 POC-POC 0.5/0.5 45X1250X3020mm", XIF(H17 === "IAGIA45", "ISPUNA KAMENA VUNA CORE BP 30 PLUS 130 kg/m3  45x1000x2400mm", XIF(H17 === "IFF0030A0045", "ISPUNA POLISTIRENE XPS 30 kg/m3 45mm", "?"))));
    // ovo ce biti uklopljeno u local virbom u glavnoj AutoCreate funkciji
    z['kamenavuna2'] = x;
  };
  console.log('z');
  console.log(z);
  return z;
};


export const derivatZaPanelIzmenjivaca = (p) => {
  let rezultat = {};

  let C17 = p.tippanela;
  let I17 = p.eliminatorkapi;
  let J17 = p.smervazduha;
  let G17 = p.sirina;
  let L17 = p.b;
  let K17 = p.a;
  let M17 = p.c;
  let O17 = p.f;
  let N17 = p.e;

  rezultat.x1 = XIF(I17 = "NE", G17 / 2 - L17 / 2, XIF(AND(I17 = "DA", J17 = "V1"), (G17 / 2) - ((K17 + L17 + M17 + 40 + 140) / 2) + K17, XIF(AND(I17 = "DA", J17 = "V2"), (G17 / 2) + (((K17 + L17 + M17 + 40 + 140) / 2) - L17 - M17), 0)));
  rezultat.y1 = XIF(J17 = "V1", 19 + O17 + N17, XIF(J17 = "V2", 19 + O17, 0));
  rezultat.x2 = XIF(I17 = "NE", G17 / 2 + L17 / 2, XIF(AND(I17 = "DA", J17 = "V1"), ((G17 / 2) - ((K17 + L17 + M17 + 40 + 140) / 2)) + K17 + L17, XIF(AND(I17 = "DA", J17 = "V2"), (G17 / 2) + (((K17 + L17 + M17 + 40 + 140) / 2) - M17), 0)));
  rezultat.y2 = XIF(J17 = "V1", 19 + O17, XIF(J17 = "V2", 19 + O17 + N17, 0));

  return rezultat;
}

